import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Popover } from 'primeng/popover';
import { Drawer } from 'primeng/drawer';
import { Tooltip } from 'primeng/tooltip';
import { ScrollPanel } from 'primeng/scrollpanel';
import { PanelMenu } from 'primeng/panelmenu';
import { ButtonModule, ButtonDirective } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { MultiSelect } from 'primeng/multiselect';
import { Card } from 'primeng/card';
import { ProgressSpinner } from 'primeng/progressspinner';
import { Dialog } from 'primeng/dialog';
import { Toast } from 'primeng/toast';
import { GalleriaModule } from 'primeng/galleria';
import { RadioButton } from 'primeng/radiobutton';
import { InputText } from 'primeng/inputtext';
import { Message } from 'primeng/message';
import { Checkbox } from 'primeng/checkbox';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { Stepper } from 'primeng/stepper';
import { InputNumber } from 'primeng/inputnumber';
import { Password } from 'primeng/password';
import { Panel } from 'primeng/panel';
import { Avatar } from 'primeng/avatar';
import { TreeSelect } from 'primeng/treeselect';
import { Listbox } from 'primeng/listbox';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Tag } from 'primeng/tag';
import { Rating } from 'primeng/rating';
import { FileUpload } from 'primeng/fileupload';
import { Toolbar } from 'primeng/toolbar';
import { Menu } from 'primeng/menu';
import { BlockUI } from 'primeng/blockui';
import { Ripple } from 'primeng/ripple';
import { MatStepperModule } from '@angular/material/stepper';
import { FloatLabel } from 'primeng/floatlabel';
import { TabsModule } from 'primeng/tabs';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { AutoComplete } from 'primeng/autocomplete';
import { Select } from 'primeng/select';
import { DatePicker } from 'primeng/datepicker';
import { ToggleButton } from 'primeng/togglebutton';
import { Skeleton } from 'primeng/skeleton';
import { Paginator } from 'primeng/paginator';
import { Tree } from 'primeng/tree';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    Select,
    ScrollPanel,
    PanelMenu,
    ButtonModule,
    TableModule,
    MultiSelect,
    Card,
    Dialog,
    DatePicker,
    Toast,
    GalleriaModule,
    InputText,
    Message,
    Checkbox,
    ToggleSwitch,
    Stepper,
    InputNumber,
    Panel,
    Password,
    Avatar,
    TreeSelect,
    Listbox,
    ConfirmDialog,
    Tag,
    Rating,
    FileUpload,
    Toolbar,
    Menu,
    BlockUI,
    Ripple,
    MatStepperModule,
    RadioButton,
    Drawer,
    TabsModule,
    FloatLabel,
    IconField,
    InputIcon,
    Popover,
    AutoComplete,
    ProgressSpinner,
    ToggleButton,
    Tooltip,
    Skeleton,
    Paginator,
    Tree,
  ],

  exports: [
    Select,
    ScrollPanel,
    PanelMenu,
    ButtonModule,
    TableModule,
    MultiSelect,
    Card,
    Dialog,
    DatePicker,
    Toast,
    GalleriaModule,
    RadioButton,
    InputText,
    Message,
    Checkbox,
    ToggleSwitch,
    Stepper,
    InputNumber,
    Panel,
    Password,
    Avatar,
    TreeSelect,
    Listbox,
    ConfirmDialog,
    Tag,
    Rating,
    FileUpload,
    Toolbar,
    Menu,
    BlockUI,
    Ripple,
    MatStepperModule,
    Drawer,
    TabsModule,
    FloatLabel,
    IconField,
    InputIcon,
    Popover,
    AutoComplete,
    ProgressSpinner,
    ToggleButton,
    Tooltip,
    Skeleton,
    Paginator,
    Tree,
  ],
})
export class SharedPrimengModule {}
